export default __webpack_public_path__ + "locales/zh-CN/Article.json?hash=63a8c57e4e77236a3cfd48507f2a7fb0";